import { media, styled } from '@payright/web-components';
import { ReactNode } from 'react';

const P = styled.p`
  color: ${(props) => props.theme.colours.blue.base};
  font-size: 1.13em;
  font-weight: bold;

  span {
    display: block;
  }

  ${media.min.medium} {
    font-size: 1.53em;
    span {
      display: inline;
    }
  }
`;

type ContractInfoProps = {
  merchantStoreName: ReactNode; // this could be string or undefined but the use allows for a reactnode
  withinAvailableCredit: boolean | undefined;
};

export const ContractInfo = ({ merchantStoreName, withinAvailableCredit }: ContractInfoProps) =>
  withinAvailableCredit ? (
    <>
      <P>Congratulations - your new BNPL Plan has been approved!</P>
      <P>Below is a summary of your new BNPL Plan.</P>
      <P>
        Your new BNPL Plan is offered under your available credit limit of your existing BNPL
        Contract.
      </P>
      <P>
        To complete your purchase with {merchantStoreName}, please review and accept the Repayment
        Schedule for this Plan. Once you've accepted these terms, you will be asked to confirm your
        repayment method and pay any applicable deposit.
      </P>
    </>
  ) : (
    <>
      <P>Congratulations - you have been approved!</P>
      <P>Below is a summary of your BNPL Plan.</P>
      <P>
        Your BNPL contract is a line of credit and allows you to make purchases of goods and
        services over time as you repay back any amounts used. The BNPL Plan is for your first
        purchase and will allow you to purchase your goods immediately as an alternative to another
        type of credit facility or making a savings plan. If this does not meet your needs and
        requirements, this product may not be right for you.
      </P>
      <P>
        To complete your purchase with {merchantStoreName}, please review your financial table and
        BNPL contract. You will then be prompted to enter your payment details and pay any
        applicable deposit.
      </P>
    </>
  );
